import * as React from "react";
const SvgFiBrandsArtstation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="m0 17.725 2.031 3.504A2.42 2.42 0 0 0 4.2 22.564h13.457l-2.792-4.839zM24 17.749c0-.485-.146-.939-.388-1.311L15.73 2.723a2.42 2.42 0 0 0-2.144-1.287H9.419l12.178 21.103 1.918-3.326c.388-.638.485-.914.485-1.464M12.874 14.286 7.428 4.851l-5.446 9.435z"
    />
  </svg>
);
export default SvgFiBrandsArtstation;
